import { Component, OnInit } from '@angular/core';


import { ExpectedExpensesService } from '../../services/expected-expenses.service';

import * as _ from 'lodash/lodash';

@Component({
  selector: 'app-list-expected-expenses',
  templateUrl: './list-expected-expenses.component.html',
  styleUrls: ['./list-expected-expenses.component.css'],
  providers:[ExpectedExpensesService]
})
export class ListExpectedExpensesComponent implements OnInit {
    p: number = 1;
    totalItems: number = 0;
    expectedExpenses: any = [];  
  
    filters:any = {
    };
  
    constructor(private expectedExpensesService: ExpectedExpensesService) { }
  
    ngOnInit() {
        this.getExpectedExpenses();
    }
  
    getExpectedExpenses(){
      var params = {
        where: _.cloneDeep(this.filters),
        sort: 'id DESC',
        skip: (this.p-1)*10,
        limit: 10
      };
      this.expectedExpensesService.query(params)
        .subscribe((expectedExpenses) => {
          this.expectedExpensesService.count({})
          .subscribe((count) => {
            this.totalItems = count.count;
          });
          this.expectedExpenses = expectedExpenses;
        });
    }

    getTypeName(type){
      return type == 1? 'Mensual':type == 2? 'Bimensual':type == 3? 'Trimestral': '';
    }

}



// WEBPACK FOOTER //
// ./src/app/expenses/components/list-expected-expenses/list-expected-expenses.component.ts